import { useState } from 'react';

import { NavItem } from 'components/navigation/NavItem';

import { SearchBarDialog } from '../../SearchBar/SearchBarDialog';

type Props = React.ComponentProps<typeof NavItem>;
export const SearchNavItem = (props: Props) => {
  const [searchDialogOpened, setSearchDialogOpened] = useState(false);

  return (
    <>
      <NavItem {...props} onClick={() => setSearchDialogOpened(true)} />
      {!!searchDialogOpened && (
        <SearchBarDialog onClose={() => setSearchDialogOpened(false)} />
      )}
    </>
  );
};
